import classNames from 'classnames/bind';
import styles from './ITTraining.module.scss';

import { useTranslation } from 'react-i18next';
import { useState } from 'react';

const cx = classNames.bind(styles);
const CONTACT_LINK = 'https://ody.com.vn';
function ITTraining() {

    const { t } = useTranslation();

    const [featureIndex, setFeatureIndex] = useState(0);

    const features = [{
        title: t('Real-World Skills'),
        content: t('Learn "combat-ready" techniques used in actual corporate environments.')
    }, {
        title: t('Beyond Textbooks'),
        content: t('We teach the essential skills often missing from university syllabuses.')
    }, {
        title: t('Career Ready'),
        content: t('Leave with the right skills to immediately benefit your organization and accelerate your career.')
    }]

    const curriculums = [
        { title: t('Software Development'), content: t('Build robust applications using modern programming languages and frameworks'), icon: require("~/assets/images/it-training/code.png") },
        { title: t('Blockchain'), content: t('Develop smart contract and decentralized application'), icon: require("~/assets/images/it-training/blockchain.png") },
        { title: t('Data & Analytics'), content: t('Unlock data insights with statistical programming languages, SQL and data visualization'), icon: require("~/assets/images/it-training/data-analytics.png") },
        { title: t('Cloud & DevOps'), content: t('Use AI in your everyday work and drive impact at your organization'), icon: require("~/assets/images/it-training/ai.png") },
        { title: t('Business Intelligence'), content: t('Collect, analyze, and present data using various Business Intelligence platforms and tools'), icon: require("~/assets/images/it-training/intelligence.png") },
        { title: t('Customized Corporate Training'), content: t('Tailored team training sessions for your organization\'s specific tech stack.'), icon: require("~/assets/images/it-training/customize.png") }
    ]
    const schedules = [
        { title: t('Fill Your Skill Gap'), content: t('With a vast range of IT courses available, we put you on the path to technical mastery'), icon: require("~/assets/images/it-training/gap.png") },
        { title: t('Expert Delivery'), content: t('Our subject matter experts deliver industry-leading content through multiple delivery formats'), icon: require("~/assets/images/it-training/university.png") },
        { title: t('Thrive in Tech'), content: t('Our courses equip you with the technical expertise to overcome work challenges and thrive in a technology-driven world'), icon: require("~/assets/images/it-training/data-analytics.png") }
    ]

    const expertiseImage = require('~/assets/images/it-training/expertise.png');
    const expertiseLogos = [
        {
            logo: require('~/assets/images/it-training/fpt.png'),
            width: 127,
            alt: 'fpt',
            url: 'https://daihoc.fpt.edu.vn/hcm'
        },
        {
            logo: require('~/assets/images/it-training/greenwich.png'),
            width: 259,
            alt: 'greenwich',
            url: 'https://www.gre.ac.uk/'
        },
        {
            logo: require('~/assets/images/it-training/erasmus.png'),
            width: 310,
            alt: 'erasmus',
            url: 'https://www.eur.nl/en'
        },
        {
            logo: require('~/assets/images/it-training/bordeaux.png'),
            width: 220,
            alt: 'bordeaux',
            url: 'https://www.u-bordeaux.fr/en'
        },
    ];

    return (
        <div className={cx('training-page')}>
            <div className={cx('training-page__hero-banner')}>
                <div className={cx('training-page__hero-banner__inner')}>
                    <div>
                        <div className={cx('training-page__badge')}>
                            {t('PREMIUM COURSE')}
                        </div>
                    </div>
                    <div className={cx('training-page__hero-banner__inner__title')}>
                        {t('Advance your career with our')}{' '}<div className={cx('training-page__hero-banner__inner__title__highlight')}>{t('application-focused')}</div>{' '}{t('courses')}
                        <div>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                    <div className={cx('training-page__hero-banner__inner__describe')}>
                        {t('We help you keep up with today’s technologies with our broad curriculum taught by subject matter experts. We ensure you’ll leave with the right skills to benefit your organization and your career.  You will get the most value for your time and training dollars.')}
                    </div>
                    <a className={cx('training-page__cta')} href={CONTACT_LINK}>
                        <span>{t('Let’s Talk')}</span>
                        <img src='/icons/angle-right.svg' alt="let talk" />
                    </a>
                </div>
            </div>

            <div className={cx('training-page__features')}>
                <div className={cx('training-page__features__inner')}>
                    <img className={cx('training-page__features__inner__image')} src={require('~/assets/images/it-training/feature-01.png')} alt='Training IT' />
                    <div className={cx('training-page__features__inner__items')}>
                        <div>
                            <div className={cx('training-page__badge')}>
                                {t('IT TRAINING')}
                            </div>
                        </div>
                        <div className={cx('training-page__features__inner__items__heading')}>
                            {t('Bridge the Gap Between Theory and Reality')}
                            <span />
                            <span />
                        </div>
                        <div className={cx('training-page__features__inner__items__content')}>
                            {t('Traditional education builds the foundation, but the industry demands practical execution. We help you keep up with today’s fast-paced technologies with a curriculum designed for the real world')}
                        </div>

                        <div className={cx('training-page__features__inner__items__list')}>
                            {
                                features.map((item, index) => (
                                    <div key={index} className={cx('training-page__features__inner__items__list__item', {
                                        // 'training-page__features__inner__items__list__item__actived': index === featureIndex
                                    })}
                                    // onClick={() => {
                                    //     setFeatureIndex(index)
                                    // }}
                                    >
                                        <div className={cx('training-page__features__inner__items__list__item__title')}>
                                            {item.title}
                                        </div>
                                        <div className={cx('training-page__features__inner__items__list__item__content')}>
                                            {item.content}
                                        </div>
                                    </div>))
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div className={cx('training-page__compound-bg')}>
                <div className={cx('training-page__curriculum')}>
                    <div className={cx('training-page__curriculum__inner')}>
                        <div className={cx('training-page__curriculum__inner__heading')}>{t('Industry-Leading Curriculum')}
                            <span />
                            <span />
                        </div>
                        <div className={cx('training-page__curriculum__inner__content')}>{t('Our subject matter experts deliver authorized content across the most in-demand fields')}</div>
                        <div className={cx('training-page__curriculum__inner__items')}>
                            {
                                curriculums.map((item, index) => <div key={index} className={cx('training-page__curriculum__inner__items__item')}>
                                    <img src={item.icon} className={cx('training-page__curriculum__inner__items__item__icon')} alt={item.title} />
                                    <div className={cx('training-page__curriculum__inner__items__item__title')}>{item.title}</div>
                                    <div className={cx('training-page__curriculum__inner__items__item__content')}>{item.content}</div>
                                </div>)
                            }
                        </div>
                    </div>
                </div>

                <div className={cx('training-page__schedule')}>
                    <div className={cx('training-page__schedule__inner')}>
                        <div className={cx('training-page__schedule__inner__left')}>
                            <div>
                                <div className={cx('training-page__badge')}>
                                    {t('IT TRAINING')}
                                </div>
                            </div>
                            <div className={cx('training-page__schedule__inner__left__heading')}>{t('Flexible IT Training Built for Your Schedule')}</div>
                            <div className={cx('training-page__schedule__inner__left__content')}>{t('We offer flexible training options that meet the needs of any IT professional, student, or organization. Whether you prefer in-person courses or other formats, we accommodate your busy schedule to ensure you get the most value for your time and effort.')}</div>
                            <a className={cx('training-page__cta', 'training-page__schedule__desktop-cta')} href={CONTACT_LINK}>
                                <span>{t('Let’s Talk')}</span>
                                <img src='/icons/angle-right.svg' alt="let talk" />
                            </a>
                        </div>
                        <div className={cx('training-page__schedule__inner__items')}>
                            {
                                schedules.map((item, index) => <div key={index} className={cx('training-page__schedule__inner__items__item')}>
                                    <div className={cx('training-page__schedule__inner__items__item__title-group')}>
                                        <img src={item.icon} className={cx('training-page__schedule__inner__items__item__icon')} alt={item.title} />
                                        <div className={cx('training-page__schedule__inner__items__item__title')}>{item.title}</div>
                                    </div>
                                    <div className={cx('training-page__schedule__inner__items__item__content')}>{item.content}</div>
                                </div>)
                            }
                        </div>
                        <a className={cx('training-page__cta', 'training-page__schedule__mobile-cta')} href={CONTACT_LINK}>
                            <span>{t('Let’s Talk')}</span>
                            <img src='/icons/angle-right.svg' alt="let talk" />
                        </a>
                    </div>
                </div>
            </div>


            <div className={cx('training-page__partner')}>
                <div className={cx('training-page__partner__inner')}>
                    <div className={cx('training-page__partner__inner__image')}>

                        <img alt="Learn from World-Class Academic Experts" src={expertiseImage} />
                    </div>

                    <div className={cx('training-page__partner__inner__right')}>
                        <div>
                            <div className={cx('training-page__badge')}>
                                {t('IT TRAINING')}
                            </div>
                        </div>

                        <div className={cx('training-page__partner__inner__right__title')}>
                            {t('Learn from World-Class Academic Experts')}
                            <span></span>
                            <span></span>
                        </div>
                        <div className={cx('training-page__partner__inner__right__content')}>
                            {t('Not just trainers—our faculty holds PhDs and Master\'s degrees and currently teaches at prestigious institutions worldwide.')}
                        </div>
                        <div className={cx('training-page__partner__inner__right__logos')}>
                            {expertiseLogos.map((item, index) => (
                                <a className={cx('training-page__partner__inner__right__logos__item')} href={item.url} target='__blank'>
                                    <img src={item.logo} width={item.width} alt={item.alt} />
                                </a>

                            ))}
                        </div>
                    </div>
                </div>
                <div className={cx('training-page__partner__inner-2')}>
                    <div className={cx('training-page__partner__inner-2__card')}>
                        <div className={cx('training-page__partner__inner-2__card__flyer')} />
                        <div className={cx('training-page__partner__inner-2__card__inner')}>
                            <div className={cx('training-page__partner__inner-2__card__title')}>
                                <div>{t('Register for Your')}</div>
                                <div>{t('IT Courses Today')}

                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                            <div className={cx('training-page__partner__inner-2__card__content')}>
                                {t('Our professional trainers with real experience in corporate environments are transferring knowledge and experience through innovative approaches to help you achieve greater success. Don\'t let the technology gap hold you back.')}
                            </div>
                            <div>
                                <a className={cx('training-page__cta')} href={CONTACT_LINK}>
                                    {t('Start Now')}
                                    <img src='/icons/angle-right.svg' alt="Start Now" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default ITTraining;
